import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SuperEjecutivoGraficaComponent } from '../super-ejecutivo-grafica/super-ejecutivo-grafica.component';
import { MENSAJES_GRAFICA_SUPER_EJECUTIVO } from '../super-ejecutivo.constants';
import { ISegmentoVisibleSuperEjecutivo } from '../super-ejecutivo.interface';
import { markdownSuperEjecutivoAHtml, segmentarRespuestaSuperEjecutivo } from './super-ejecutivo-markdown.util';

/**
 * Único lugar que muestra el Markdown del Super Ejecutivo (respuestas y propuestas). Separa los bloques
 * ```grafica y los dibuja con `app-super-ejecutivo-grafica` (requerimiento `super-ejecutivo-graficas`); una
 * gráfica inválida muestra su aviso sin romper el resto (RN8.1) y una que sigue llegando, mientras el mensaje
 * esté `enCurso`, el aviso de gráfica en camino (RN8.2). Sin encapsulación porque el HTML llega por
 * `innerHTML`; sus estilos van bajo la clase `super-ejecutivo-markdown`.
 */
@Component({
  selector: 'app-super-ejecutivo-markdown',
  templateUrl: './super-ejecutivo-markdown.component.html',
  styleUrl: './super-ejecutivo-markdown.component.css',
  imports: [MatIcon, MatProgressSpinner, SuperEjecutivoGraficaComponent],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuperEjecutivoMarkdownComponent {
  /** Markdown tal como lo escribió el Super Ejecutivo. */
  public readonly texto = input.required<string>();
  /** El texto sigue llegando por el stream: un bloque de gráfica abierto todavía puede cerrarse (RN8.2). */
  public readonly enCurso = input(false);

  public readonly segmentos = computed<ISegmentoVisibleSuperEjecutivo[]>(() =>
    segmentarRespuestaSuperEjecutivo(this.texto(), this.enCurso()).map((segmento) =>
      segmento.tipo === 'markdown' ? { tipo: 'markdown', html: markdownSuperEjecutivoAHtml(segmento.texto) } : segmento,
    ),
  );

  public readonly graficaNoValida = MENSAJES_GRAFICA_SUPER_EJECUTIVO.GRAFICA_NO_VALIDA;
  public readonly graficaEnCamino = MENSAJES_GRAFICA_SUPER_EJECUTIVO.GRAFICA_EN_CAMINO;
}
